<template>
  <div>
    <!-- 搜索 -->
    <div class="search-inner">
      <div id="components-form-demo-advanced-search">
        <a-form class="ant-advanced-search-form">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item class="name" label="课程ID">
                <a-input class="form-cell" type="number" placeholder="请输入" v-model="queryParam.courseId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="name" label="课程名称">
                <a-input class="form-cell" type="text" placeholder="请输入" v-model="queryParam.courseName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="价格范围">
                <a-input-group compact style="min-width: 168px">
                  <a-input-number :min="0" :precision="2" v-model="queryParam.minPrice" class="price-scope"
                    placeholder="请输入" />
                  <a-input class="price-gap" placeholder="~" disabled />
                  <a-input-number :min="0" :precision="2" v-model="queryParam.maxPrice" class="price-scope max-price"
                    placeholder="请输入" />
                </a-input-group>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="roleId != 4">
              <a-form-item label="课程分类">
                <a-select class="form-cell" placeholder="请选择" v-model="queryParam.classifyId" @change="changeClassifId">
                  <a-select-option v-for="(item, index) in classifyList" :key="index" :value="item.id">{{
                    item.tagName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="课程类型">
                <a-select class="form-cell" :disabled="queryParam.classifyId == '3'" placeholder="请选择"
                  v-model="queryParam.cateFirstId">
                  <a-select-option v-for="(item, index) in $store.state.common.courseCateLevel" :key="index"
                    :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="roleId != 3">
              <!-- 课程来源 -->
              <a-form-item label="课程来源">
                <a-select class="form-cell" placeholder="请选择" v-model="queryParam.sourceType"
                  @change="sourceTypeChange">
                  <a-select-option v-for="(item, index) in $store.getters.courseType" :key="index" :value="item.value"
                    :class="{ padding0: item.value == '1' && isInstitution }"><span
                      v-if="item.value != '1' || !isInstitution">{{
                        item.code
                      }}</span></a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="roleId == 6">
              <!-- 课程方种类 -->
              <a-form-item label="课程方种类">
                <a-select class="form-cell" placeholder="请选择" v-model="queryParam.institutionType"
                  :disabled="queryParam.sourceType != 2">
                  <a-select-option v-for="(item, index) in institutionTypeList" :key="index" :value="item.id"><span>{{
                    item.value }}</span></a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <!-- 审核状态 -->
              <a-form-item label="审核状态">
                <a-select class="form-cell" placeholder="请选择" v-model="queryParam.status">
                  <a-select-option value="3">待提交</a-select-option>
                  <a-select-option value="0">待审核</a-select-option>
                  <a-select-option value="4">初审通过</a-select-option>
                  <a-select-option value="5">复审通过</a-select-option>
                  <a-select-option value="1">审核通过</a-select-option>
                  <a-select-option value="2">审核不通过</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="课程梯度">
                <a-select placeholder="请选择" class="form-cell" v-model="queryParam.tagCycle">
                  <a-select-option v-for="item in courseCycleList" :key="item.id" :value="item.id">
                    {{ item.tagName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="课程周期">
                <a-select placeholder="请选择" class="form-cell" v-model="queryParam.tagGradient">
                  <a-select-option v-for="item in courseGradientList" :key="item.id" :value="item.id">
                    {{ item.tagName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="站点" v-if="roleId == '6'">
                <a-select show-search class="form-cell" placeholder="请选择" v-model="queryParam.bureauId"
                  :filter-option="filterOption">
                  <a-select-option v-for="(item, index) in bureauList" :key="index" :value="item.id">{{ item.bureauName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="margin-top: 10px">
            <a-col :span="24" :style="{ textAlign: 'right' }">
              <a-button type="primary" @click="searchCourse()" :style="{ marginRight: '8px' }">查询</a-button>
              <a-button @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="cl-inner">
      <!-- 操作 -->
      <div class="table-title">
        <div class="list-oper">
          <a-button type="primary" v-if="isOper" @click="$refs.courseForm.init('add')">新建</a-button>
          <a-button class="refer-audit" type="primary" v-if="roleId == 4" @click="submitAudit(false)"
            :disabled="allIndex != 3">批量提交审核</a-button>
          <!-- 只有学校才有权限 -->
          <template v-if="isSchool">
            <template v-if="openAllIndex == '0'">
              <a-dropdown>
                <a class="ant-dropdown-link">
                  <a-button type="primary" class="select-course-button">批量操作</a-button>
                </a>
                <a-menu slot="overlay">
                  <a-menu-item key="0" @click="openAllChange('1')">
                    <span class="custom-menu-item">批量加入选课</span>
                  </a-menu-item>
                  <a-menu-item key="1" @click="openAllChange('2')">
                    <span class="custom-menu-item">批量停用选课</span>
                  </a-menu-item>
                  <a-menu-item key="2" @click="openAllChange('3')">
                    <span class="custom-menu-item">批量提交审核</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
            <template v-else-if="openAllIndex == '1'">
              <a-button type="primary" class="select-course-button" @click="addSelectCourse(false, true)"
                :disabled="!(openAllIndex == 1 && selectedRowKeys.length > 0)">加入选课</a-button>
              <a-button type="primary" class="select-course-button" @click="openAllIndex = '0'">取消</a-button>
            </template>

            <template v-else-if="openAllIndex == '2'">
              <a-button type="primary" class="select-course-button" @click="addSelectCourse(false, false)"
                :disabled="!(openAllIndex == 2 && selectedRowKeys.length > 0)">移除选课</a-button>
              <a-button type="primary" class="select-course-button" @click="openAllIndex = '0'">取消</a-button>
            </template>
            <template v-else-if="openAllIndex == '3'">
              <a-button type="primary" class="select-course-button" @click="submitAudit(false)"
                :disabled="allIndex != 3">提交审核</a-button>
              <a-button type="primary" class="select-course-button" @click="openAllIndex = '0'">取消</a-button>
            </template>
          </template>

          <div class="import-excel">
            <a class="download hover-font-active" @click="exportCourse">Excel导出</a>
          </div>
        </div>
      </div>

      <div class="table-circle">
        <a-table :columns="columns" :dataSource="courseList" class="c-table" :loading="loading" :pagination="pagination"
          @change="tableChange" :rowKey="record => record.id"
          :rowSelection="(openAllIndex != '0' || (roleId == '4' && openAllIndex == '0')) ? rowSelection : null">
          <span slot="courseName" slot-scope="text, record">
            <template>
              <p v-if="roleId == 3 && record.isPlatform == 1">
                <img style="margin-bottom: 6px; width: 82px; height: 20px" src="../../assets/isPlatform.png" />
              </p>
              <p>{{ record.courseName }}</p>
            </template>
          </span>

          <span slot="statusText" slot-scope="text, record">
            <template v-if="$store.state.common.tags">
              <a-tag style="border-radius: 50%; vertical-align: middle; padding: 3px" :color="record.statusText === '审核通过'
                ? '#68CC2E'
                : record.statusText === '审核不通过'
                  ? '#FA5151'
                  : '#FFA91F'
                ">
              </a-tag>
              {{ record.statusText }}
            </template>
          </span>

          <span slot="price" slot-scope="text, record" class="price">
            <template v-if="$store.state.common.tags">
              <div>总价格：{{ (record.totalPrice === -1 ? 0 : record.totalPrice) / 100 }}</div>
              <div>课时总价：{{ record.coursePrice / 100 }}</div>
              <div>教材/教具：{{ record.textbookPrice / 100 }}</div>
            </template>
          </span>
          <span slot="cateFirstName" slot-scope="text, record">
            <template v-if="$store.state.common.tags">
              <a-tag class="classify" color="blue">
                {{ record.classifyId | classifyFilter }}
              </a-tag>
              <br />
              <a-tag :color="record.cateFirstName === '体育'
                ? 'green'
                : record.cateFirstName === '智育'
                  ? 'purple'
                  : record.cateFirstName === '美育'
                    ? 'pink'
                    : record.cateFirstName === '劳育'
                      ? 'red'
                      : 'orange'
                ">
                {{ record.cateFirstName }}
              </a-tag>
            </template>
          </span>
          <span slot="providerNameList" slot-scope="text, record">
            <template>
              <span>{{
                record.providerNameList ? record.providerNameList.join(',') : ''
              }}
                <a-tag v-if="record.institutionType == 3" color="blue">
                  高协
                </a-tag></span>
            </template>
          </span>
          <span slot="gradeScope" slot-scope="text, record">
            <template>
              <a :title="record.gradeScope | gradeScopeFilter" style="color: #000000a6">{{ record.gradeScope |
                gradeScopeFilter }}</a>
            </template>
          </span>
          <span slot="courseLevel" slot-scope="text, record">
            <template>
              <span>{{ record.courseLevel | courseLevel }}</span>
            </template>
          </span>
          <span slot="serviceSchoolNameList" slot-scope="text, record">
            <template>
              <span class="table-limit-height">{{
                record.serviceSchoolNameList
                  ? record.serviceSchoolNameList.join(',')
                  : ''
              }}</span>
            </template>
          </span>
          <span slot="gmtModified" slot-scope="text, record">
            <template>
              <span>{{ text ? text : record.gmtCreate }}</span>
            </template>
          </span>
          <span slot="action" slot-scope="text, record">
            <template>
              <a @click="$refs.courseDetail.init('', record)">{{
                record.status == '0' && isEducation ? '审核' : '详情'
              }}</a>

              <a v-if="record.status == '3' || record.status == '2'" @click="submitCourse(record.id)">&nbsp; 提交审核</a>

              <a-dropdown v-if="isOper">
                <a-button style="margin-left: 8px; color: #1890ff; border: none">更多
                  <a-icon type="down" />
                </a-button>
                <a-menu slot="overlay">
                  <a-menu-item key="5" v-if="roleId == 3 && record.isRecommend == 0"
                    @click="$refs.personForm.init('add', record)">添加推荐</a-menu-item>
                  <a-menu-item key="1" v-if="record.controlUpdateButton" @click="editConfirm(record)">
                    修改
                  </a-menu-item>

                  <a-menu-item key="2" v-if="roleId == '6'">
                    <a @click="$refs.courseForm.init('copy', record)">复制</a>
                  </a-menu-item>
                  <a-menu-item key="4" v-if="openAllIndex == '0' && isSchool && record.selectStatus != '0'">
                    <a @click="addSelectCourse(true, false, record)">停用</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </span>
        </a-table>
      </div>

      <course-form-modal ref="courseForm" @addCourse="addCourse" @updateCourse="updateCourse"></course-form-modal>

      <course-detail-modal ref="courseDetail" @updateCourse="updateCourse"
        @back-modify="backModify"></course-detail-modal>
      <person-password-modal ref="personPassword"></person-password-modal>
      <manager-form-modal ref="personForm" @addPerson="addPerson"></manager-form-modal>
    </div>
  </div>
</template>
<script>
import CTable from '../../components/CTable'

import person from '../../api/person'

import course from '../../api/course'

import CourseFormModal from './CourseFormModal'

import CourseDetailModal from './CourseDetailModal'
import PersonPasswordModal from './PersonPasswordModal'
import ManagerFormModal from './ManagerFormModal'
import institution from '../../api/institution'

import school from '../../api/school'

import { analysisAddress } from '../../utils/address'

import bureau from '../../api/bureau'

import Vue from 'vue'

import { Select, Tooltip } from 'ant-design-vue'
import user from '../../api/user'

export default {
  name: 'courseList',
  data() {
    return {
      courseList: [], //课程数据
      columns: [
        {
          key: 'id',
          title: '课程ID',
          dataIndex: 'id',
          width: 80,
        },
        {
          title: '课程名称',
          dataIndex: 'courseName',
          // width: 90,
          scopedSlots: {
            customRender: 'courseName',
          },
        },
        {
          title: '审核状态',
          dataIndex: 'statusText',
          // width: 90,
          scopedSlots: {
            customRender: 'statusText',
          },
        },
        {
          title: '课时数/节',
          dataIndex: 'classHours',
          sorter: true,
          width: 100,
        },
        {
          title: '建议教学时长范围/分钟',
          dataIndex: 'teachingTime',
          // width: 60,
        },
        // {
        //   title: '课时总价',
        //   dataIndex: 'coursePrice',
        //   scopedSlots: { customRender: 'coursePrice' },
        //   width: 60,
        // },
        // {
        //   title: '教材/教具价格',
        //   dataIndex: 'textbookPrice',
        //   scopedSlots: { customRender: 'textbookPrice' },
        //   width: 80,
        // },
        // {
        //   title: '总价格',
        //   dataIndex: 'totalPrice',
        //   scopedSlots: { customRender: 'totalPrice' },
        //   width: 70,
        // },
        {
          title: '金额',
          dataIndex: 'price',
          scopedSlots: {
            customRender: 'price',
          },
          width: 125,
        },
        // {
        //   title: '课程分类',
        //   dataIndex: 'classifyId',
        //   scopedSlots: { customRender: 'classifyId' },
        //   width: 90,
        // },
        {
          title: '课程类型',
          dataIndex: 'cateFirstName',
          scopedSlots: {
            customRender: 'cateFirstName',
          },
          // width: 40,
        },
        {
          title: '适用年级',
          dataIndex: 'gradeScope',
          scopedSlots: {
            customRender: 'gradeScope',
          },
          ellipsis: true,
          width: 110,
        },
        {
          title: '提供方',
          dataIndex: 'providerNameList',
          scopedSlots: {
            customRender: 'providerNameList',
          },
          // width: 70,
        },
        {
          title: '课程级别',
          dataIndex: 'courseLevel',
          scopedSlots: {
            customRender: 'courseLevel',
          },
          // width: 60,
        },
        {
          title: '课程来源',
          dataIndex: 'sourceTypeText',
          // width: 60,
        },
        {
          title: '课程方种类',
          dataIndex: 'institutionTypeName',
          // width: 60,
        },
        {
          title: '服务学校',
          dataIndex: 'serviceSchoolNameList',
          scopedSlots: {
            customRender: 'serviceSchoolNameList',
          },
          // width: 70,
        },
        {
          title: '创建时间',
          dataIndex: 'gmtCreate',
          sorter: true,
          width: 100,
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action',
          },
          // width: 120,
        },
      ],
      classifyList: [],
      allIndex: undefined,
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        showLessItems: true,
        showSizeChanger: true,
      }, //分页数据对象
      selectedRowKeys: [],
      rowSelect: null,
      pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
      // pagination: {
      //   showTotal: (total) => `总共 ${total} 条`, // 显示总数
      // }, //分页数据对象
      currentPage: {}, // 分页
      teaBureauSetting: Vue.ls.get('teaBureauSetting'),
      loading: true,
      searchInstitutionLoading: false, //搜索课程方loading
      institutionList: [], //课程方list
      searchSchoolLoading: false, //搜索学校loading
      schoolList: [], //学校list
      isOper: false, //是否具有操作权限
      isSchool: false, //角色是否是学校
      isInstitution: false, //角色是否是课程方
      isEducation: false, //是否是教育局

      openAllIndex: '0', //是否开启全部选择  0不开启，1批量选课，2批量移除选课
      allSelectListId: [], //选择的list中的ID
      allSelectList: [], //选择的list
      bureauList: [], //站点LIST
      roleId: -1, //角色id
      institutionTypeList: [
        { id: 1, value: '社会企业' },
        { id: 2, value: '个人老师' },
        { id: 3, value: '高校与协会' },
      ],
      courseNeedCheck: false,
      courseCycleList: [],
      courseGradientList: [],
    }
  },
  components: {
    CTable,
    CourseFormModal,
    CourseDetailModal,
    PersonPasswordModal,
    ManagerFormModal,
  },
  computed: {
    rowSelection() {
      let _this = this;
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onSelectAll: (selected, selectedRows, changeRows) => {
        },
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          let arr2 = []
          selectedRows.map((item) => {
            arr2.push(item.status)
          })
          // 全选的状态
          this.allIndex = arr2.every((item) => {
            return item == arr2[0];
          }) && arr2[0];
          this.allSelectListId = []
          this.allSelectList = []
          for (let i in selectedRows) {
            this.allSelectListId.push(selectedRows[i].id)
          }
          this.allSelectList = utils.common.copy(selectedRows)
        },
        getCheckboxProps: ((record) => {
          return {
            props: {
              disabled: ((_this.openAllIndex == '1' && record.totalPrice === -1) || (_this.openAllIndex == '3' && record.status !== 3) || (_this.roleId == 4 && _this.openAllIndex == '0' && record.status !== 3)) ? true : false,
            }
          }
        }),
      }
    },
  },
  methods: {
    editConfirm(record) {
      let _this = this;
      if (record && record.status == 1 && record.statusText == '审核通过' && this.courseNeedCheck) {
        this.$confirm({
          title: '确定要修改课程?',
          content: '本课程“' + record.courseName + '”当前是“审核通过”通过状态，如果您修改保存本课程，将会再次进入审核状态，审核通过之前学校不可选课不可开班。',
          onOk() {
            _this.editConfirm2nd(_this, record);
          },
          onCancel() { },
        });
      } else {
        //不是审核，或不要求审核，只提示一次
        _this.editConfirm2nd(_this, record);
      }
    },
    editConfirm2nd(_this, record) {
      let courseSelected = (record.selectStatus == 1);
      if (courseSelected) //已选则需要提醒编辑影响已开班
        _this.$confirm({
          title: '确定要修改课程?',
          content: '确认继续修改可能会导致目前使用本课程“已开班”的班级受到影响，请问继续修改本课程内容吗？',
          onOk() {
            _this.$refs.courseForm.init('update', record)
          },
          onCancel() { },
        });
      else
        _this.$refs.courseForm.init('update', record);//未选可直接编辑
    },
    handleDisabled(index) {
      this.data[index].disabled = !this.data[index].disabled;
      // 这一步重新赋值才能实现动态改变disabled
      this.data = [...this.data];
    },
    //批量提交
    submitAudit(isSingle, value) {
      let req = {
        courseIds: isSingle ? value.id : this.allSelectListId.join(','),
        schoolId: this.$store.getters.userInfo.schoolId,
      }
      course.submitCourse(req).then((res) => {
        this.queryParam.currentPage = this.currentPage.currentPage
        this.allSelectListId = [];
        this.selectedRowKeys = [];
        this.allSelectList = [];
        this.courseList = [];
        this.rowSelection.onChange([], []);
        this.searchCourse('openAllChange')
      })
    },
    sourceTypeChange(value) {
      if (value == 1) {
        this.queryParam.institutionType = undefined
      }
    },
    openAllChange(value) {
      this.openAllIndex = value
      let { total, current, ...params } = this.pagination
      params.currentPage = this.pagination.current
      this.searchCourse('openAllChange')
      // this.getCourseList(params)
      // this.rowSelection()
    },
    //导出课程
    exportCourse(e) {
      let _this = this;
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon: 'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          for (let key in _this.queryParam) {
            if (_this.queryParam[key] == undefined) {
              _this.queryParam[key] = ''
            }
          }
          // console.log('this.queryParam', _this.queryParam)
          _this.$message.success('导出中...')
          course.exportCourse(_this.queryParam).then((res) => {
            const url = window.URL.createObjectURL(res.data) //URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a') //设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none'
            dom.href = url
            dom.setAttribute('download', '课程列表.xlsx')
            document.body.appendChild(dom)
            dom.click()
          })
        },
      })

    },
    changeClassifId(e) {
      if (this.roleId == 3) {
        if (e) {
          this.queryParam.schoolCourseFlag = e ? 0 : 1
        }
      }
      this.$forceUpdate()
    },
    //加入选课
    addSelectCourse(isSingle, isAdd, value) {
      if (isAdd === true && value && value.totalPrice === -1) {
        this.$error({ title: '课程暂未定价，无法加入选课' })
        return
      }
      let req = {
        courseIds: isSingle ? value.id : this.allSelectListId.join(','),
        schoolId: this.$store.getters.userInfo.schoolId,
        selectStatus: isAdd ? '1' : '0', //选课状态：0-未选（移除），1-已选（选课
      }
      course.selectOrRemove(req).then((res) => {
        if (isSingle && isAdd) {
          this.$message.success('选课成功')
        } else if (isSingle && !isAdd) {
          this.$message.success('停用成功')
        } else if (!isSingle && isAdd) {
          this.$message.success('批量选课成功')
        } else {
          this.$message.success('批量停用成功')
        }

        //数据回显
        // console.log(this.allSelectList)
        this.allSelectList = isSingle ? [value] : this.allSelectList
        for (let i in this.courseList) {

          for (let j in this.allSelectList) {
            if (this.allSelectList[j].id == this.courseList[i].id) {
              this.$set(this.courseList[i], 'selectStatus', req.selectStatus)
            }
          }
        }
        // console.log(this.courseList, this.courseList[0].totalPrice, '123456789104851')

        //关闭批量选课
        this.openAllIndex = '0'
        this.queryParam.currentPage = this.currentPage.currentPage
        this.selectedRowKeys = [];
        this.searchCourse('openAllChange')
      })
    },

    // 提交审核
    async submitCourse(courseId) {
      await course.submitCourse({ courseIds: courseId }).then((res) => {
        console.log(res)
      })
      this.queryParam.currentPage = this.currentPage.currentPage
      this.getCourseList(this.queryParam)
    },

    //是否有操作权限
    judgeIsOper() {
      this.$store.dispatch('getUserInfo').then((res) => {
        //只有课程方，学校、平台才有权限
        let roleId = res.accRole.id.toString()
        this.roleId = roleId
        if (['3', '4', '6'].indexOf(roleId) != -1) {
          this.isOper = true
        } else {
          this.isOper = false
        }
        this.isSchool = roleId == '3' ? true : false
        this.isInstitution = roleId == '4' ? true : false
        this.isEducation = roleId == '2' ? true : false
        //学校 去掉课程来源
        if (this.isSchool) {
          this.classifyList = [{ id: '', tagName: '全部' }, { id: 2, tagName: '社团课' }, { id: 3, tagName: '托管班' }]
          this.queryParam.classifyId = 2
          this.columns.splice(8, 1)
          this.columns.splice(9, 3)
        }

        //课程方 去掉课程级别，提供方
        if (this.isInstitution) {
          this.classifyList = [{ id: 1, tagName: '特色课' }]
          this.queryParam.classifyId = 1
          this.columns.splice(9, 2)
        }

        //平台管理员
        if (roleId == '6') {
          this.classifyList = this.$store.getters.getClassify
          this.columns.unshift({
            title: '站点',
            dataIndex: 'bureauName',
            width: 150,
          })
        }
        this.columns.splice(-1, 0, {
          title: '修改时间',
          dataIndex: 'gmtModified',
          scopedSlots: {
            customRender: 'gmtModified',
          },
          sorter: true,
          width: 100,
        })
        this.getCourseList(this.queryParam)
        this.getCourseCheckSetting();
      })

    },

    //搜索课程方
    searchInstitution(val = '') {
      this.searchInstitutionLoading = true
      institution
        .searchInstitution({
          institutionName: val,
        })
        .then((res) => {
          this.searchInstitutionLoading = false
          this.institutionList = res.data
        })
    },

    //搜索学校
    searchSchool(val = '') {
      this.searchSchoolLoading = true
      school
        .searchSchool({
          schoolName: val,
        })
        .then((res) => {
          this.searchSchoolLoading = false
          this.schoolList = res.data
        })
    },

    // 搜索站点
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    reset(){
      this.queryParam = {}
      if (this.roleId == 3) {
        this.queryParam.classifyId = 2
      }
      if (this.roleId == 4) {
        this.queryParam.classifyId = 1
      }
    },
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      this.currentPage.currentPage = pagination.current
      //如果查询有地址的话，把地址解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${sorter.order == 'ascend' ? 'asc' : 'desc'
          }`
      }
      this.getCourseList(obj)
    },
    showSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.current = current
      this.tableChange(this.pagination)
    },

    //新增一个课程
    addCourse(course) {
      this.getCourseList(this.queryParam)
    },

    updateCourse(course) {
      this.queryParam.currentPage = this.currentPage.currentPage
      this.queryParam.pageSize = this.pagination.pageSize
      this.getCourseList(this.queryParam)
    },

    //获取代理列表
    selectSearchBureau(val = '', id) {
      let req = {
        bureauName: val,
      }
      if (id) {
        req.id = id
      }
      bureau.selectSearchBureau(req).then((res) => {
        this.bureauList = res.data
      })
    },


    //查询课程
    searchCourse(value) {
      let req = JSON.parse(JSON.stringify(this.queryParam))
      if (req.minPrice) {
        req.minPrice = utils.common.accMul(req.minPrice, 100)
      }
      if (req.maxPrice) {
        req.maxPrice = utils.common.accMul(req.maxPrice, 100)
      }
      if (value == 'openAllChange') {
        req.currentPage = this.pagination.current
        req.pageSize = this.pagination.pageSize
      } else {
        req.currentPage = 1
        req.pageSize = 10
      }
      if (this.roleId == 3) {
        req.providerId = this.$store.getters.userInfo.schoolId
        if (!req.classifyId) req.schoolCourseFlag = 1
      }
      this.getCourseList(req)
    },

    //课程列表
    getCourseList(params) {
      this.loading = true
      course.getCourseList_all(params).then((res) => {
        for (let i in res.data.list) {
          res.data.list[i].key = res.data.list[i].id
        }
        this.courseList = res.data.list || []
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },
    //加入推荐
    //新增推荐
    addPerson() {
      this.dataSource = []
      // this.getPersonList();
      this.getCourseList()
    },
    // 退回修改
    backModify(course) {
      this.$refs.courseForm.init('update', course)
    },
    getCourseCheckSetting() {
      let _thisPage = this;
      let courseCheckSetting = this.isSchool ? "school_course_status" : (this.isInstitution ? "noSchool_course_status" : null);
      if (courseCheckSetting) {
        bureau.getBureauSetting(courseCheckSetting).then(res => {
          if (res.code == 0 && res.data && res.data.length == 1) {
            _thisPage.courseNeedCheck = (res.data[0].settingValue == "1");
          }
        });
      }
    }
  },
  handleButtonClick(e) {
    console.log('click left button', e)
  },
  handleMenuClick(e) {
    console.log('click', e)
  },
  created() {
    this.courseCycleList = Vue.ls.get('courseCycle').filter(item => item.parentId !== 0)
    this.courseGradientList = Vue.ls.get('courseGradient').filter(item => item.parentId !== 0)
    this.judgeIsOper()
    this.selectSearchBureau()
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

// input::-webkit-outer-spin-button,
// input::-webkit-inner-spin-button {
//   -webkit-appearance: none;
// }
.search-inner {
  width: calc(100% - 40px);
  background: white;
  margin: 20px auto;
  padding: 16px 24px;
  box-sizing: border-box;
}

.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
  // overflow-x: auto;
}

.search-oper {
  button {
    margin: 0px 5px;
  }
}

.list-oper {
  margin: 20px 0px 30px;
}

.table-title {
  height: 52px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .list-title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
}

.price {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  div:nth-child(1) {
    font-size: 14px;
    font-weight: 500;
    color: #35383e;
  }
}

.classify {
  margin-bottom: 8px;
}

/deep/ .ant-tag {
  border: 0;
}

.price-scope {
  width: 70px;
  text-align: center;
}

.max-price {
  border-left: none;
}

.price-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}

.select-course-button {
  margin-left: 20px;
}

.table-limit-height {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.import-excel {
  display: inline-block;
  margin-left: 20px;
  position: relative;

  .download {
    display: inline-block;
    margin-left: 20px;
    text-decoration: underline;
    color: $primary-color-dark;
    position: relative;
    z-index: 2;
  }
}

.ant-advanced-search-form {
  padding: 24px;
  border-radius: 6px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

.ant-advanced-search-form .ant-form-item {
  margin-bottom: 0;
}

.ant-advanced-search-form {
  padding: 0;
}

// .table-circle ::v-deep .ant-pagination-total-text {}

// .table-circle{
//   display: block;
// }
// .table-active{
//   display: none;
// }

.fenye {
  text-align: right;
  padding-top: 20px;
}

.refer-audit {
  margin-left: 20px;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: #FFF;
  color: #000;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;

  /* 淡入 - 1秒内从 0% 到 100% 显示: */
  opacity: 0;
  transition: opacity 1s;
  border: 1px solid black;
  text-align: left;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>
